import { Empty as AntdEmpty, Flex } from "antd";
import { createStyles } from "antd-style";

import { Typography } from "./typography/Typography";

import type { AvE2EProps } from "../types";
import type { EmptyProps as AntdEmptyProps } from "antd/lib";

const useStyles = createStyles(({ token, css }) => ({
  emptyStateText: css`
    font-size: ${token.fontSizeLG}px;
  `,
  emptyStateImage: css`
    &.ant-empty .ant-empty-image {
      height: 28px;
    }
  `,
}));

type EmptyProps = AvE2EProps &
  AntdEmptyProps & {
    description: string;
    secondaryDescription?: string;
    isDescriptionBold?: boolean;
  };

export function Empty(props: EmptyProps) {
  const {
    testIdPrefix,
    description,
    secondaryDescription,
    isDescriptionBold = false,
    ...restProps
  } = props;
  const { styles } = useStyles();
  const { Text } = Typography;

  return (
    <AntdEmpty
      data-testid={`${testIdPrefix}-empty`}
      image={<img src="/monocle-emoji.gif" alt="monocle emoji" />}
      description={
        <Flex vertical align="center" gap={4}>
          <Text
            testIdPrefix={`${testIdPrefix}-empty-desc`}
            strong={isDescriptionBold}
            className={styles.emptyStateText}
          >
            {description}
          </Text>
          {secondaryDescription && (
            <Text testIdPrefix={`${testIdPrefix}-empty-secondary-desc`}>
              {secondaryDescription}
            </Text>
          )}
        </Flex>
      }
      {...restProps}
      className={styles.emptyStateImage}
    />
  );
}
